// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fa-0";